import React from 'react';
import Popup from "reactjs-popup";
import LogoImage from './LogoImage';
import "../sass/components/processing.scss"

// Shown to the customer when an invoice PDF can't be generated.
const InvoiceErrorModal = ({open, invoiceNumber, onClose}) => (
    <Popup open={open} onClose={onClose} modal closeOnDocumentClick>
        {close => (
            <div className="confirm-error-modal">
                <div className='close_modal' onClick={close}>&times;</div>
                <LogoImage className="header-logo-img"/>
                <p>Sorry, we couldn't generate {invoiceNumber ? `invoice ${invoiceNumber}` : 'this invoice'} right now.</p>
                <p>Our team has been notified. If you need a copy in the meantime, please contact us:</p>
                <div className="confirm-error-modal__contacts">
                    {process.env.REACT_APP_PHONE && <a href={`tel:${process.env.REACT_APP_PHONE}`}><i className="fas fa-icon fa-phone"></i>{process.env.REACT_APP_PHONE}</a>}
                    {process.env.REACT_APP_EMAIL && <a href={`mailto:${process.env.REACT_APP_EMAIL}`}><i className="fas fa-icon fa-envelope"></i>{process.env.REACT_APP_EMAIL}</a>}
                </div>
            </div>
        )}
    </Popup>
);

export default InvoiceErrorModal;
